import { useTranslation } from "react-i18next";
import type { AssignmentStatus } from "@/types/test";

const STYLE: Record<AssignmentStatus, string> = {
  active: "bg-primary/10 text-primary ring-primary/20",
  submitted: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  expired: "bg-muted text-muted-foreground ring-border",
};

const DOT: Record<AssignmentStatus, string> = {
  active: "bg-primary",
  submitted: "bg-emerald-500",
  expired: "bg-muted-foreground/40",
};

export function AssignmentStatusBadge({ status }: { status: AssignmentStatus }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex w-fit items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${STYLE[status]}`}
    >
      <span aria-hidden className={`size-1.5 rounded-full ${DOT[status]}`} />
      {t(`tests.status.${status}`)}
    </span>
  );
}
